import Em from 'ember';
let vendor = navigator.vendor || '';
let userAgent = navigator.userAgent || '';
let platform = Em.Object.extend({
  needsOffscreenPaste: Em.computed('isSafari', function () {
    return this.get('isIE10') || this.get('isIE11') || this.get('isSafari');
  }),
  // Needs a dependent key so we can enable this in tests

  modifierKeyName: Em.computed(function () {
    return this.get('isMac') ? '&#8984;' : 'Ctrl';
  }),
  isSafari: Em.computed(function () {
    return vendor.indexOf('Apple') === 0 && /\sSafari\//.test(userAgent);
  }),
  isIE10: Em.computed(function () {
    return userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:10') > -1;
  }),
  isIE11: Em.computed(function () {
    return userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11') > -1;
  }),
  isMac: Em.computed(function () {
    return navigator.platform.indexOf('Mac') > -1;
  }),
  isLinux: Em.computed(function () {
    return navigator.platform.indexOf('Linux') > -1;
  }),
  isWindows: Em.computed(function () {
    return navigator.platform.indexOf('Win') > -1;
  }),
  isFirefox: Em.computed(function () {
    return userAgent.indexOf('Firefox') > -1;
  }),
  isEdge: Em.computed(function () {
    return userAgent.indexOf('Edge') > -1;
  })
});
export default platform.create();